import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { WA_NUMBER, WA_MESSAGES } from '../constants'

export default function Navbar() {
  const [open, setOpen] = useState(false)
  const { pathname } = useLocation()

  const leftLinks = [
    { to: '/#treks', label: 'Treks' },
    { to: '/departures', label: 'Departures' },
  ]
  const rightLinks = [
    { to: '/about', label: 'About' },
    { to: '/blog', label: 'Blog' },
  ]
  const allLinks = [...leftLinks, ...rightLinks]

  const waHref = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_MESSAGES.general)}`

  const linkStyle = to => ({
    fontSize: '13px',
    color: pathname === to ? 'var(--green)' : 'var(--ink-mid)',
    fontWeight: pathname === to ? 500 : 400,
  })

  return (
    <nav style={{
      position: 'sticky', top: 0, zIndex: 100,
      background: 'rgba(255,255,255,0.96)',
      backdropFilter: 'blur(8px)',
      borderBottom: '1px solid var(--stone-mid)',
      padding: '0 5%',
      height: '62px',
    }}>
      {/* Desktop: left links | centered logo | right links + primary CTA */}
      <div className="nav-links-desktop" style={{
        display: 'grid',
        gridTemplateColumns: '1fr auto 1fr',
        alignItems: 'center',
        height: '100%',
        gap: '24px',
      }}>
        <ul style={{ display: 'flex', gap: '28px', listStyle: 'none' }}>
          {leftLinks.map(l => (
            <li key={l.to}><Link to={l.to} style={linkStyle(l.to)}>{l.label}</Link></li>
          ))}
        </ul>

        <Link to="/" style={{ fontFamily: 'var(--serif)', fontSize: '22px', fontWeight: 600, color: 'var(--ink)', whiteSpace: 'nowrap' }}>
          ktm <span style={{ color: 'var(--green)' }}>travel guide</span>
        </Link>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '28px' }}>
          <ul style={{ display: 'flex', gap: '28px', listStyle: 'none' }}>
            {rightLinks.map(l => (
              <li key={l.to}><Link to={l.to} style={linkStyle(l.to)}>{l.label}</Link></li>
            ))}
          </ul>
          <a href={waHref} target="_blank" rel="noreferrer" className="btn btn-green btn-sm">
            WhatsApp Me
          </a>
        </div>
      </div>

      {/* Mobile: hamburger | centered logo | WhatsApp icon */}
      <div className="nav-hamburger" style={{ alignItems: 'center', justifyContent: 'space-between', height: '100%' }}>
        <button
          onClick={() => setOpen(o => !o)}
          aria-label="Menu"
          aria-expanded={open}
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '8px', color: 'var(--ink)' }}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            {open ? (
              <>
                <line x1="5" y1="5" x2="19" y2="19" />
                <line x1="19" y1="5" x2="5" y2="19" />
              </>
            ) : (
              <>
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </>
            )}
          </svg>
        </button>

        <Link to="/" style={{ fontFamily: 'var(--serif)', fontSize: '20px', fontWeight: 600, color: 'var(--ink)' }}>
          ktm <span style={{ color: 'var(--green)' }}>travel guide</span>
        </Link>

        <a href={waHref} target="_blank" rel="noreferrer" aria-label="WhatsApp" style={{ color: 'var(--green)', display: 'flex' }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
            <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.123 1.528 5.862L0 24l6.335-1.527A11.945 11.945 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.849 0-3.587-.504-5.083-1.385l-.364-.215-3.76.906.923-3.68-.237-.378A9.946 9.946 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
          </svg>
        </a>
      </div>

      {/* Mobile dropdown panel */}
      {open && (
        <div style={{
          position: 'absolute', top: '62px', left: 0, right: 0,
          background: 'var(--white)', borderBottom: '1px solid var(--stone-mid)',
          boxShadow: 'var(--shadow-md)', padding: '16px 5% 24px',
          display: 'flex', flexDirection: 'column', gap: '4px',
        }}>
          {allLinks.map(l => (
            <Link
              key={l.to} to={l.to} onClick={() => setOpen(false)}
              style={{
                padding: '12px 0', fontSize: '15px',
                color: pathname === l.to ? 'var(--green)' : 'var(--ink)',
                borderBottom: '1px solid var(--stone-mid)',
              }}
            >
              {l.label}
            </Link>
          ))}
          <a href={waHref} target="_blank" rel="noreferrer" className="btn btn-green" style={{ marginTop: '16px', justifyContent: 'center' }}>
            WhatsApp Me
          </a>
        </div>
      )}
    </nav>
  )
}
